import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import VerifyOTP from "../../Pages/Login/VerifyOTP.js";
import ChangePassword from "../../Pages/Login/ChangePassword.js";
import ForgotPassword from "../../Pages/Login/ForgetPassword.js";
import ResetPassword from "../../Pages/Login/ResetPassword.js";
import CandidateLogin from "../ApplicantsLogin/ApplicantsLogin.js";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={"/"} />} />
      <Route exact path="/" element={<CandidateLogin />} />
      <Route exact path="/candidatelogin" element={<CandidateLogin />} />
      <Route extact path="/verifyotp" element={<VerifyOTP />} />
      <Route extact path="/changepassword" element={<ChangePassword />} />
      <Route extact path="/forgotpassword" element={<ForgotPassword />} />
      <Route extact path="/resetpassword" element={<ResetPassword />} />
    </Routes>
  )
}
export default AppRoutes;